import { render, staticRenderFns } from "./PWS01G03.vue?vue&type=template&id=d375b88c&scoped=true"
import script from "./PWS01G03.vue?vue&type=script&lang=js"
export * from "./PWS01G03.vue?vue&type=script&lang=js"
import style0 from "./PWS01G03.vue?vue&type=style&index=0&id=d375b88c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d375b88c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d375b88c')) {
      api.createRecord('d375b88c', component.options)
    } else {
      api.reload('d375b88c', component.options)
    }
    module.hot.accept("./PWS01G03.vue?vue&type=template&id=d375b88c&scoped=true", function () {
      api.rerender('d375b88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pws/PWS01G03.vue"
export default component.exports